import { Language } from 'store/slices/language-slice';

interface ProfileNavigationMessages {
  profileNavigationMessages: {
    header: string;
    bankingDetails: string;
    recurringBuys: string;
    linkedAccounts: string;
    cryptoWithdrawlAddress: (productName: string) => string;
    updateEmailAddress: string;
    changePassword: string;
    backToProfileButton: string;
    disabledEmailHeader: string;
    disabledEmailContent: (supportEmail: string) => string;
    loginMethod: string;
  };
}

type Message = {
  [key in Language]: ProfileNavigationMessages;
};

const messages: Message = {
  en: {
    profileNavigationMessages: {
      recurringBuys: 'Recurring Buys',
      header: 'Account Details',
      bankingDetails: 'Linked Bank Details',
      linkedAccounts: 'Linked accounts',
      cryptoWithdrawlAddress: (productName: string) =>
        `${productName} Withdrawal Address`,
      updateEmailAddress: 'Update Email Address',
      changePassword: 'Change Password',
      disabledEmailContent: (supportEmail: string) =>
        `This has been temporarily disabled, please contact ${supportEmail} for urgent requests.`,
      disabledEmailHeader: 'Please note',
      backToProfileButton: 'Back to profile',
      loginMethod: 'Login Method',
    },
  },
  // deu: {
  //     profileNavigationMessages: {
  //         header: 'Kontodetails',
  //         bankingDetails: 'Bankverbindung',
  //         linkedAccounts: 'Verknüpfte Konten',
  //         bitcoinAddress: 'Bitcoin-Adresse',
  //         tetherAddress: 'USD Tether-Adresse',
  //         updateEmailAddress: 'E-Mail-Adresse aktualisieren',
  //         changePassword: 'Passwort ändern',
  //         disabledEmailContent: (supportEmail: string) =>
  //             `Dies wurde vorübergehend deaktiviert.Bitte wenden Sie sich an ${supportEmail} für dringende Anfragen.`,
  //         disabledEmailHeader: 'Bitte beachten Sie',
  //         backToProfileButton: 'Zurück zum Profil',
  //         loginMethod: 'Anmeldeverfahren',
  //     },
  // },
};

export default messages;
